import Question from "./Question";
import React from "react";
import { Button, CardActions, Box, Card, CardContent, Typography, Divider, Grid } from "@material-ui/core";
import { withRouter } from "react-router";
import axios from "axios";
import Cookies from "js-cookie";

import { createMuiTheme, responsiveFontSizes, ThemeProvider } from '@material-ui/core/styles';
//import { ThreeSixty } from "@material-ui/icons";

import questions from "./data/questions.json";

let theme = createMuiTheme();
theme = responsiveFontSizes(theme);

/**
 * アンケート形式で集計を行い診断をする
 */
class QuestionBoard2 extends React.Component {

  /**
   * コンストラクタ
   * @param {*} props
   */
  constructor(props) {
    super(props);
    this.state = {
      // ストレスチェック
      questions: questions
    };
  }

  /*
   * 入力hook、本来はreduxとかでやるべき
   */
  handleValue(i, v, type) {
    if (type === "STRESS") {
      const questions = this.state.questions.slice();
      questions[i]["value"] = parseInt(v, 10);
      this.setState({ questions: questions });
    }
  }

  /*
   * 回答チェック
   */
  isComplete() {
    const first = this.state.questions.filter((i) => { return i.value === -1 }).length === 0;
    return first;

  }


  /**
   * 質問表を作成
   * @param {*} i
   * @param {*} type
   */
  generate_questions(i, type) {
    if (type === "STRESS") {
      return (<Question
        value={this.state.questions[i]}
        labels={["全く当てはまらない", "当てはまらない", "当てはまる", "非常に当てはまる"]}
        onValueChange={(v) => {
          this.handleValue(i, v, "STRESS")
        }}></Question>)
    }
  }

  /**
   *　Cardを生成
   * @param {*} title
   * @param {*} description
   * @param {*} list
   * @param {*} next
   */
  renderCard(title, description, list, next) {
    return (
      <Box mx="auto" p={1}>
        <Card id={title}>
          <CardContent>
            <Typography variant="h4" component="h4">
              {title}
            </Typography>
            <Typography variant="body1" component="p">
              {description}
            </Typography>
            <Divider></Divider>
            <Box p={1}></Box>
            {list}
          </CardContent>
          <CardActions>
            {next}
          </CardActions>
        </Card>
      </Box>
    )
  }

  /**
   * 次へ
   * @param {*} next
   */
  generate_next_link(next) {
    if (next === "STRESS") {
      if (!this.isComplete(next)) {
        return <Button disabled bgcolor="blue">回答してください</Button>
      } else {
        return <Button variant="contained" color="primary" onClick={() => this.nextPage()}>結果を見る</Button>
      }
    }
    return (<div></div>);
  }

  generate_list() {
    return {
      "kimochi": this.state.questions.map(i => {
        return i.value + 1
      })
    }
  }

  categorize() {
    const orange = this.state.questions.filter(i => { return i.type === "ORANGE" }).reduce((p, x) => p + (x.value + 1), 0);
    const blue = this.state.questions.filter(i => { return i.type === "BLUE" }).reduce((p, x) => p + (x.value + 1), 0);
    const yellow = this.state.questions.filter(i => { return i.type === "YELLOW" }).reduce((p, x) => p + (x.value + 1), 0);
    const green = this.state.questions.filter(i => { return i.type === "GREEN" }).reduce((p, x) => p + (x.value + 1), 0);
    const white = this.state.questions.filter(i => { return i.type === "WHITE" }).reduce((p, x) => p + (x.value + 1), 0);
    return [
      {
        rank: "緊張と興奮", value: orange, average: 13.18
      },
      {
        rank: "爽快感", value: blue, average: 18.87
      },
      {
        rank: "疲労感", value: yellow, average: 16.66
      },
      {
        rank: "抑うつ感", value: green, average: 15.24
      },
      {
        rank: "不安感", value: white, average: 19.35
      }
    ]
  }

  nextPage() {
    // send spread sheet
    const tmp = this.generate_list();
    console.log(tmp);
    const apiurl = "https://script.google.com/macros/s/AKfycbyqxKce-ifBasOEK3qFjtvDwQ20A0cOdRfp9DgwYKxgfxwL08l_/exec";
    const CORS_PROXY = "https://cors-anywhere.herokuapp.com/";

    axios.create({
      headers: {
        "Content-Type": "application/json"
      }
    }).post(
      CORS_PROXY + apiurl, JSON.stringify(tmp)
    ).then((res) => {
      console.log(res);
    }).catch((err) => {
      console.log(err);
    });

    // write cookie
    Cookies.set("k-mental-second", JSON.stringify(this.categorize()), { expires: 1 });

    this.props.history.push("/Result2");

    // this.props.history.push(
    //   {
    //     pathname: "/Result",
    //     state: { result: this.categorize_2nd() }
    //   });

  }

  /**
   *
   */
  render() {
    var q_list = [];
    this.state.questions.forEach((i, index) => { q_list.push(this.generate_questions(index, "STRESS")) });

    return (
      <ThemeProvider theme={theme}>
        <Grid container alignItems="center" justify="center">
          <Grid item xs={11}>
            {this.renderCard("4. 気持ちのチェックリスト", "次の項目をよく読んで、今のあなたの状態にもっともよく当てはまると思うものを選んでください。", q_list, this.generate_next_link("STRESS"))}
          </Grid>
        </Grid >
      </ThemeProvider >
    )
  }
}

export default withRouter(QuestionBoard2);

//         <h1>ストレスチェック: {this.countValue()}</h1>
        // <h2>全回答: {this.complete()}</h2>
        // <h2>安定度: {this.kibun_huantei()}</h2>
